import React, { useState, useRef, useEffect } from 'react';
import "./style.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../sidebar";
import Header from "../header";
import permissionModel from "../../../models/permisstion.model";
import ApiClient from "../../../methods/api/apiClient";
import methodModel from "../../../methods/methods";
import environment from "../../../environment";
import { FcOvertime } from "react-icons/fc";
import { BsExclamationTriangle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { login_success } from "../../../redux/actions/user";
import Footer from '../footer/index'
import gsap from 'gsap';


const Layout = ({ children }) => {
  const user = useSelector((state) => state.user);
  const { id } = useParams()
  const token = sessionStorage.getItem("token")
  const history = useNavigate();
  const [isOpen, setIsopen] = useState(false);
  const dispatch = useDispatch();
  const urlPath = window.location.pathname

  useEffect(() => {
    if (!urlPath.includes('blog') && !urlPath.includes('card') && !urlPath.includes('contactus') && !urlPath.includes('terms') && !urlPath.includes('privacy') && !urlPath.includes('aboutus') && !urlPath.includes('faq')) {
      if (!token) {
        history("/");
      }
    }
  }, []);

  const logo = () => {
    let value = "/assets/img/logos.jpg";
    return value;
  };

  const logowhite = () => {
    let value = "/assets/img/logos.jpg";
    return value;
  };

  const logos = () => {
    let value = "/assets/img/logos.jpg";
    return value;
  };

  const router = () => {
    let route = sessionStorage.getItem("route");
    history(route);
  };

  // useEffect(() => {
  //   setstate(sessionStorage.getItem("sidebar"));
  // }, [sessionStorage.getItem("sidebar")]);

  // const [showHomePage, setShowHomePage] = useState(false);
  // const homePageRef = useRef(null);

  // useEffect(() => {
  //   if (showHomePage) {
  //     gsap.fromTo(homePageRef.current, { scale: 0 }, { scale: 1, duration: 1 });
  //   }
  // }, [showHomePage]);

  // const handleVideoEnd = () => {
  //   setShowHomePage(true);
  // };



  return (
    <>
      <div className='' component="layout">


        {/* {!showHomePage ? (
        <video
          className="video"
          autoPlay
          muted
          onEnded={handleVideoEnd}
        >
          <source src="/assets/img/open.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div className="" ref={homePageRef}>
        <div onClick={(e) => router()} id="routerDiv"></div>
          <Header isOpen={isOpen} setIsOpen={setIsopen} />
  
          {children}
      
          <Footer/>
  
        </div>
      )} */}


        <div className="" >
          <div onClick={(e) => router()} id="routerDiv"></div>
          <Header isOpen={isOpen} setIsOpen={setIsopen} />

          {children}

          <Footer />

        </div>



        {/* <div className={`main-wrapper flex ${isOpen ? "active-sidebar" : ""}`}>
          <div className="main-sidebar scrollbar transition-[width] duration-300" 
          
          >
            <div className="sidebar-brand text-center">
              <Link to="/">
                <div className="editLogo">
                  <img
                    src={logowhite()}
                   
                    className="h-32  show-logo mb-3"
                  />
                  <img src={logos()} className="hide-logo" />
                </div>
              </Link>
            </div>
            {user?.logo ? (
              <div
                className="flex justify-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={methodModel.userImg(user?.logo || "")}
                  alt="photo"
                  width="40"
                  height="40"
                  style={{
                    width: "40px",
                    marginBottom: "2px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>
            ) : null}
            <Sidebar isOpen={isOpen} />
          </div>
          <main className="main">
            <div className="mainarea">
             
            </div>
          </main>
        </div> */}
      </div>
    </>
  );
};
export default Layout;
